import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import WaLink, { eyebrow } from './WaLink';
import { gallery } from '../data/salon';
import GalleryLightbox from './GalleryLightbox';

const whyPhoto = 'https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/1e06c24fd3597a05b7c8da6d911932bf.webp';
const reasons = [
  ['FiAward', 'Experienced beauticians'],
  ['FiShield', 'Spotless hygiene'],
  ['FiStar', 'Quality products'],
  ['FiHeart', 'Personalised service'],
  ['FiSmile', 'Happy clients'],
];

function Why() {
  return (
    <section className="mx-auto grid max-w-[1280px] items-center gap-10 px-4 py-20 sm:px-6 lg:grid-cols-2">
      <div className="relative h-[460px] overflow-hidden rounded-t-[220px] rounded-b-2xl">
        <img src={whyPhoto} alt="Treatment in progress" className="h-full w-full object-cover" />
      </div>
      <div>
        <span className={eyebrow}>Why choose us</span>
        <h2 className="font-display mt-3 text-4xl text-[#0B3B36] sm:text-5xl">
          Care in <em className="text-[#C8553D]">every detail.</em>
        </h2>
        <div className="mt-8 grid gap-3 sm:grid-cols-2">
          {reasons.map(([icon, label]) => (
            <div key={label} className="flex items-center gap-4 rounded-xl border border-[#0B3B36]/10 bg-white p-4">
              <span className="grid h-11 w-11 place-items-center rounded-lg bg-[#0B3B36] text-[#E9A23B]">
                <SafeIcon icon={FiIcons[icon]} />
              </span>
              <h3 className="font-display text-lg text-[#0B3B36]">{label}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Gallery() {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <section id="gallery" className="bg-[#F3E6CF] py-20">
      <div className="mx-auto max-w-[1280px] px-4 sm:px-6">
        <div className="mb-10">
          <span className={eyebrow}>Our work gallery</span>
          <h2 className="font-display mt-3 text-4xl text-[#0B3B36] sm:text-5xl">
            Looks we <em className="text-[#C8553D]">love.</em>
          </h2>
        </div>
        <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
          {gallery.map((src, index) => (
            <button
              key={`${src}-${index}`}
              type="button"
              aria-label={`Open beauty work image ${index + 1}`}
              onClick={() => setActiveIndex(index)}
              className="gallery-lightbox-trigger img-zoom group relative block aspect-[3/4] overflow-hidden rounded-2xl"
            >
              <img src={src} alt={`Beauty work ${index + 1}`} className="h-full w-full object-cover" />
              <span className="absolute right-3 top-3 grid h-9 w-9 place-items-center rounded-full bg-[#E9A23B] text-[#0B3B36] opacity-0 transition group-hover:opacity-100 group-focus-visible:opacity-100">
                <SafeIcon icon={FiIcons.FiMaximize2} />
              </span>
            </button>
          ))}
        </div>
      </div>
      {activeIndex !== null && (
        <GalleryLightbox
          images={gallery}
          index={activeIndex}
          onChange={setActiveIndex}
          onClose={() => setActiveIndex(null)}
        />
      )}
    </section>
  );
}

export { Why, Gallery };
